$(document).ready(function() {
// Swiper: Slider
    $('.swiper').each(function() {
        var $this = $(this);
        var isCustom = $this.closest('.custom_slider_grid').length > 0;

        new Swiper(this, {
            loop: true,
            slidesPerView: 1,
            paginationClickable: true,
            navigation: {
              nextEl: $this.find('.swiper-button-next').length ? $this.find('.swiper-button-next')[0] : '.swiper-button-next',
              prevEl: $this.find('.swiper-button-prev').length ? $this.find('.swiper-button-prev')[0] : '.swiper-button-prev',
            },
            spaceBetween: 10,
            breakpoints: isCustom ? {
                1920: {
                    slidesPerView: 5,
                    spaceBetween: 20
                },
                1028: {
                    slidesPerView: 5,
                    spaceBetween: 15
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 10
                },
                480: {
                    slidesPerView: 2,
                }
            } : {
                1920: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                1028: {
                    slidesPerView: 3,
                    spaceBetween: 15
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 10
                },
                480: {
                    slidesPerView: 2,
                }
            }
        });
    });




    // cart page slider 
    new Swiper('.swiper-cart-box', {
        loop: true,
        slidesPerView: 2,
        paginationClickable: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        spaceBetween: 10,
        breakpoints: {
            1920: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            1028: {
                slidesPerView: 2,
                spaceBetween: 15
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 10
            }
        }
    });
});

